module.exports = __webpack_public_path__ + "img/SKMJ_che.94a49467.jpg";